module.exports = __webpack_public_path__ + "static/fonts/NotoSansCJKkr-Light.4af942d.otf";